enum ROUTES {
  BLACKLIST = '/blocklist',
  BLACKLIST_LIST = '/blocklist/list',
  BLACKLIST_LIST_RESULTS = '/blocklist/list/results',
  BLACKLIST_LIST_USERS = '/blocklist/list/users',
  BLACKLIST_LIST_CREATE = '/blocklist/list/results/create',
  BLACKLIST_USERS_CREATE = '/blocklist/list/users/create',
  BLACKLIST_USER = '/blocklist/list/users/:userId/:blocklistId',
  BLACKLIST_ITEM = '/blocklist/:itemId',
  BLACKLIST_ITEM_SETTINGS = '/blocklist/:itemId/settings',
  BLACKLIST_ITEM_ADD_RECORD = '/blocklist/:itemId/add-record',
  BLACKLIST_ITEM_CHANGE_LOG = '/blocklist/:itemId/change-logs',
  BLACKLIST_ITEM_EDIT_RECORD = '/blocklist/:itemId/edit-record/:recordId',
  BLACKLIST_ITEM_USER_INFO = '/blocklist/:itemId/user/:userId',

  RISK_LEVELS = '/risk-levels',
  RISK_LEVELS_CREATE = '/risk-levels/create',
  RISK_LEVELS_EDIT = '/risk-levels/:settingId',

  GEOGRAPHICAL = '/geographical-risk',
  GEOGRAPHICAL_ITEM = '/geographical-risk/:id',

  TRANSACTIONS_RISK = '/transactions-risk',
  TRANSACTIONS_RISK_GEOGRAPHICAL = '/transactions-risk/geographical',
  TRANSACTIONS_RISK_VOLUME_RISK = '/transactions-risk/volume-risk',
  TRANSACTIONS_RISK_VOLUME_RISK_CREATE = '/transactions-risk/volume-risk/create',
  TRANSACTIONS_RISK_VOLUME_RISK_EDIT = '/transactions-risk/volume-risk/:itemId',
  TRANSACTIONS_RISK_CALCULATION = '/transactions-risk/calculation-rules',
  TRANSACTIONS_RISK_TYPES_RISK = '/transactions-risk/types-risk',
  TRANSACTIONS_RISK_TYPES_RISK_CREATE = '/transactions-risk/types-risk/create',
  TRANSACTIONS_RISK_TYPES_RISK_EDIT = '/transactions-risk/types-risk/:typeId',

  INDIVIDUAL_CLIENTS_RISK = '/individual-clients-risk',
  INDIVIDUAL_CLIENTS_RISK_GEOGRAPHICAL = '/individual-clients-risk/geographical',
  INDIVIDUAL_CLIENTS_RISK_VOLUMES = '/individual-clients-risk/volumes',
  INDIVIDUAL_CLIENTS_RISK_VOLUMES_CREATE = '/individual-clients-risk/volumes/create',
  INDIVIDUAL_CLIENTS_RISK_VOLUMES_EDIT = '/individual-clients-risk/volumes/:itemId',
  INDIVIDUAL_CLIENTS_RISK_PRODUCTS = '/individual-clients-risk/products',
  INDIVIDUAL_CLIENTS_RISK_PRODUCTS_CREATE = '/individual-clients-risk/products/create',
  INDIVIDUAL_CLIENTS_RISK_PRODUCTS_EDIT = '/individual-clients-risk/products/:productId',
  INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS = '/individual-clients-risk/delivery-channels',
  INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS_CREATE = '/individual-clients-risk/delivery-channels/create',
  INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS_EDIT = '/individual-clients-risk/delivery-channels/:channelId',
  INDIVIDUAL_CLIENTS_RISK_ACTIVITIES = '/individual-clients-risk/activities',
  INDIVIDUAL_CLIENTS_RISK_ACTIVITIES_CREATE = '/individual-clients-risk/activities/create',
  INDIVIDUAL_CLIENTS_RISK_ACTIVITIES_EDIT = '/individual-clients-risk/activities/:activityId',
  INDIVIDUAL_CLIENTS_RISK_SOURCE_OF_FUNDS = '/individual-clients-risk/source-of-funds',
  INDIVIDUAL_CLIENTS_RISK_SOURCE_OF_FUNDS_CREATE = '/individual-clients-risk/source-of-funds/create',
  INDIVIDUAL_CLIENTS_RISK_SOURCE_OF_FUNDS_EDIT = '/individual-clients-risk/source-of-funds/:sourceId',

  CORPORATE_CLIENTS_RISK = '/corporate-clients-risk',
  CORPORATE_CLIENTS_RISK_GEOGRAPHICAL = '/corporate-clients-risk/geographical',
  CORPORATE_CLIENTS_RISK_VOLUMES = '/corporate-clients-risk/volumes',
  CORPORATE_CLIENTS_RISK_VOLUMES_CREATE = '/corporate-clients-risk/volumes/create',
  CORPORATE_CLIENTS_RISK_VOLUMES_EDIT = '/corporate-clients-risk/volumes/:itemId',
  CORPORATE_CLIENTS_RISK_PRODUCTS = '/corporate-clients-risk/products',
  CORPORATE_CLIENTS_RISK_PRODUCTS_CREATE = '/corporate-clients-risk/products/create',
  CORPORATE_CLIENTS_RISK_PRODUCTS_EDIT = '/corporate-clients-risk/products/:productId',
  CORPORATE_CLIENTS_RISK_DELIVERY_CHANNELS = '/corporate-clients-risk/delivery-channels',
  CORPORATE_CLIENTS_RISK_DELIVERY_CHANNELS_CREATE = '/corporate-clients-risk/delivery-channels/create',
  CORPORATE_CLIENTS_RISK_DELIVERY_CHANNELS_EDIT = '/corporate-clients-risk/delivery-channels/:channelId',
  CORPORATE_CLIENTS_RISK_DATE_OF_INCORPORATION = '/corporate-clients-risk/date-of-incorporation',
  CORPORATE_CLIENTS_RISK_DATE_OF_INCORPORATION_CREATE = '/corporate-clients-risk/date-of-incorporation/create',
  CORPORATE_CLIENTS_RISK_DATE_OF_INCORPORATION_EDIT = '/corporate-clients-risk/date-of-incorporation/:dateId',
  CORPORATE_CLIENTS_RISK_SIC_CODES = '/corporate-clients-risk/sic-codes',
  CORPORATE_CLIENTS_RISK_SIC_CODE = '/corporate-clients-risk/sic-codes/:id',

  TRANSACTION_MONITORING_RULES = '/transaction-monitoring-rules',
  TRANSACTION_MONITORING_RULES_CREATE = '/transaction-monitoring-rules/create',
  TRANSACTION_MONITORING_RULES_EDIT = '/transaction-monitoring-rules/:ruleId',
}

export default ROUTES;
